import style from "./style.scss";
import { useEffect, useCallback } from "preact/hooks";
import { usePopup } from "./context";
import { mergeClasses } from "../helpers";

const Popup = ({
  children,
  ariaLabel = null,
  ariaLabelledBy = null,
  fullWidth = false,
  hideClose = false,
  squareCorners = false,
}) => {
  const popup = usePopup();

  const close = useCallback(() => {
    popup.hidePopup();
  }, [popup]);

  useEffect(() => {
    // Keyboard events
    const handleKeydown = (e) => {
      if (e.key == "Escape") {
        close();
      }
    };

    window.addEventListener("keydown", handleKeydown);
    return () => window.removeEventListener("keydown", handleKeydown);
  }, [close]);

  // Priority logic: If ariaLabelledBy is passed, ignore ariaLabel completely.
  // Using undefined ensures Preact completely strips unused attributes from the DOM.
  const computedLabelledBy = ariaLabelledBy || undefined;
  const computedLabel = computedLabelledBy ? undefined : ariaLabel || undefined;

  return (
    <div
      class={style.popup}
      role="dialog"
      aria-modal="true"
      aria-label={computedLabel}
      aria-labelledby={computedLabelledBy}
    >
      <div class={style.closeBackground} onClick={close} />
      <div class={style.wrapper}>
        {!hideClose && (
          <button
            type="button"
            aria-label="Close dialog"
            onClick={close}
            class={style.closeButton}
          />
        )}
        <div
          class={mergeClasses([
            style.content,
            squareCorners ? style.squareCorners : null,
          ])}
        >
          <div
            class={mergeClasses([
              style.contain,
              fullWidth ? style.fullWidth : null,
            ])}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
